import { IToastNotification } from "@/core/composables/notification/types";
import {
  PainelDeIntegracaoesGateway,
  TWebservice
} from "../services/PainelDeIntegracaoesGateway";
import { diContainer } from "@/inversify.config";
import { DITypes } from "@/core/@types/types";

export default function useToggleIntegracao(
  gateway: PainelDeIntegracaoesGateway
) {
  const notification = diContainer.get<IToastNotification<string>>(
    DITypes.NOTIFICATION
  );

  const toggleIntegracao = async (
    toggle: boolean,
    row?: TWebservice
  ): Promise<boolean> => {
    if (!row) return false;

    try {
      const response = await gateway.toggleIntegracao(
        row._id ?? row.id ?? "",
        toggle
      );

      if (!response?.Ok) {
        notification.showNotification(
          response?.Error ??
            `Erro ao ${toggle ? "ativar" : "desativar"} integração`,
          { type: "error" }
        );

        return false;
      }

      notification.showNotification(
        `Integração ${toggle ? "ativada" : "desativada"} com sucesso`,
        {
          type: "success"
        }
      );

      return true;
    } catch (error) {
      console.error(error);

      return false;
    }
  };

  return {
    toggleIntegracao
  };
}
